<template lang="pug">
  div(class="block")
    h3(class="title")
      | {{title}}
    component(:is="icon", v-if="icon", class="icon")
    div(class="value")
      | 10,000
      br
      span 名
</template>
<script>
  export default {
    props: {
      icon: { type: Object, default: undefined },
      title: { type: String, required: true },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .block {
    position: relative;
    text-align: center;
    @include mq('sm') {
      transform: scale(0.7);
    }
    @include mq {
      transform: scale(1);
    }
  }
  .title {
    display: inline-flex;
    align-items: center;
    font-size: 2.4rem;
    font-weight: 300;
    color: $c-pink-dark;
    padding: 0 0.3em;
    margin-bottom: 1em;
    @include mq('sm') {
      font-size: 3.5rem;
      border-width: 5px;
    }
  }
  .icon {
    display: block;
    width: 190px;
    height: 214.05px;
    margin-left: auto;
    margin-right: auto;
    @include mq('sm') {
      width: 310px;
      height: 349.25px;
      margin-right: -14px;
    }
  }
  .value {
    position: absolute;
    top: 36%;
    left: 50%;
    font-size: 10rem;
    font-family: 'Bebas Neue';
    color: $c-pink-dark;
    line-height: 1;
    text-align: right;
    vertical-align: top;
    transform: translateX(-50%);
    span {
      font-size: 2rem;
      font-weight: 300;
      vertical-align: top;
    }
    @include mq('sm') {
      font-size: 17rem;
      span {
        font-size: 3.5rem;
      }
    }
  }
</style>
